function modalContentLoaded(elSelector, callback) {
    let element;
    let interval;
    let timeMS = 0;

    // Check for interval every 100ms,
    // if element found clear interval and call callback.
    // Else keep looking for 1000ms then stop
    interval = setInterval(() => {
        element = document.querySelector(elSelector);
        timeMS += 100;
        if (element) {
            clearInterval(interval);
            callback(element);
        }
        if (timeMS > 1000) { clearInterval(interval); }
    }, 100);
}

export default modalContentLoaded;